import axios from "axios";

import {
    Toast
} from 'vant';
// 创建axios实例
const service = axios.create({
    baseURL: process.env.VUE_APP_API,
    timeout: 2000000 // 请求超时时间(因为需要调试后台,所以设置得比较大)
})
// request拦截器,在请求之前做一些处理
service.interceptors.request.use(
    config => {
        config.headers['Content-Type'] = 'application/json;charset=UTF-8'
        return config
    },
    error => {
        // 处理请求错误
        console.log(error)
        return Promise.reject(error)
    }
);
// response 拦截器,数据返回后进行一些处理
service.interceptors.response.use(
    response => {
        if (response.data.code !== 200 && response.data.code !== 401) {
            Toast(response.data.message);
        }
        return response.data

    },
    error => {
        console.log(error) // for debug
        Toast('网络失败，请稍后再试！');
        // return Promise.reject(error)
    }
);
const leave_service = axios.create({
    baseURL: process.env.VUE_APP_LEAVE_API,
    timeout: 2000000 // 请求超时时间(因为需要调试后台,所以设置得比较大)
})
// request拦截器,在请求之前做一些处理
leave_service.interceptors.request.use(
    config => {
        config.headers['Content-Type'] = 'application/json;charset=UTF-8'
        return config
    },
    error => {
        // 处理请求错误
        console.log(error)
        return Promise.reject(error)
    }
);
// response 拦截器,数据返回后进行一些处理
leave_service.interceptors.response.use(
    response => {
        if (response.data.code !== 200 && response.data.code !== 401) {
            Toast(response.data.message);
        }
        return response.data

    },
    error => {
        console.log(error) // for debug
        Toast('网络失败，请稍后再试！');
        // return Promise.reject(error)
    }
);
export {
    service,
    leave_service
}